var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3B3B58",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.184V4a1,1,0,0,0-2,0V5H5V4A1,1,0,0,0,3,4v8.184A3,3,0,0,0,1,15v5a1,1,0,0,0,2,0V19H21v1a1,1,0,0,0,2,0V15A3,3,0,0,0,21,12.184ZM19,12H18V10a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1v2H5V7H19ZM8,12V11h3v1Zm5-1h3v1H13ZM3,15a1,1,0,0,1,1-1H20a1,1,0,0,1,1,1v2H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.ddb3d0ac371c83903948462fcca4163b.svg";
export { ForwardRef as ReactComponent };